import { RenewBillableEventDto } from '../dtos/renew-billable-event.dto';

/**
 * Renew billable events response DTO
 */
export class RenewBillableEventsResponse {
	records!: RenewBillableEventDto[];
}
